import { useCallback, useEffect, useState } from 'react';
import api from '@/lib/api';

/**
 * Fetches the current doctor's monthly AI-pull quota.
 * Returns { tier, used, limit, remaining, eligible, reason?, loading, refresh }.
 * Turbo: eligible=true, limit=2.
 * Free/Premium: eligible=false, limit=0.
 */
export default function useAiQuota() {
  const [state, setState] = useState({
    tier: 'free', used: 0, limit: 0, remaining: 0, eligible: false, loading: true,
  });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/dashboard/ai-quota');
      setState({ ...data, loading: false });
    } catch {
      setState(s => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...state, refresh };
}
